import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['bornInUk'],
  validate (value, { bornInUk = false }) {
    const message = 'The date of UK resident should not be in future.';

    if (!bornInUk) {
      const dateOfUkResident = new UtcDate(value);
      const todayUtc = new UtcDate();

      if (dateOfUkResident.isAfter(todayUtc)) return message;
    }

    return {
      valid: true,
      required: !bornInUk,
    };
  },
};
